<template>
    <FormSelectTree ref="FormSelectTree" v-bind="{ ...$attrs, alwaysOpen: true }" :class="{'selectable':selectable}" v-on="$listeners" />
</template>



<script>
    import FormSelectTree from '@/components/common/FormSelectTree.vue';

    export default {
        name: 'Tree',
        inheritAttrs: false,
        components: {
            FormSelectTree,
        },
        props: {
            selectable: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>



<style lang="scss" scoped>
    .vue-treeselect {
        ::v-deep {
            * {
                z-index: 1 !important;
            }
            .vue-treeselect__control {
                display: none;
            }
            .vue-treeselect__menu-container,
            .vue-treeselect__menu,
            .vue-treeselect__list {
                margin: 0 !important;
                padding: 0 !important;
                bottom: 0 !important;
                position: relative !important;
                max-height: unset !important;
                box-shadow: unset !important;
                border: unset !important;
                border-radius: unset !important;
            }
            .vue-treeselect__menu,
            .vue-treeselect__option--highlight,
            .vue-treeselect__option--selected {
                background: none;
            }
            .vue-treeselect__label-container {
                cursor: default;
            }
        }

        &.selectable {
            ::v-deep {
                .vue-treeselect__option {
                    &.vue-treeselect__option--selected {
                        color: $primary;
                    }
                }
            }
        }
    }
</style>
